// removed by extract-text-webpack-plugin
module.exports = {"semiLargeFont":"1.375rem","largeFont":"1.625rem","row":"_2lpf3 _32f2G","buttonContainer":"_3B5SJ _25En3","button":"_3fwJ0 I9zSN","info":"_2Szfv ynC0i","heading":"_3E9D_ ynC0i","subheading":"_1uqzJ ynC0i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/fieldrow/style.css
// module id = 893
// module chunks = 0